import styled from "styled-components";
import Theme from "../../Styles/Themes";
import config from "../../Config/config.json";
import SVG from "react-inlinesvg";

export const Container = styled.div`
    align-items: center;
    display: flex;
    gap: 6px;
    justify-content: ${props => props.$aling};
    width: 100%;
`;

export const TextLabel = styled.label`
    color: ${Theme[config.theme].colors.primaryFontColor};
    display: flex;
    font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.labels[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
`;

export const Icon = styled(SVG)`
    background: #FFFFFF;
    border: none;
    height: 16px;
    width: 16px;
    
    @media (min-width: 720px) {
        height: 18px;
        width: 18px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 16px;
        width: 16px;
    }
`;